import React from "react";

const ReadOnlyRow = ({ tableRecord, handleEditClick, handleDeleteClick, handlePreviewMultimediaClick }) => {

  return (
    <tr>
      <td className="td-tee">{tableRecord.name}</td>
      <td className="td-tee">{tableRecord.description}</td>
      <td className="td-tee">{tableRecord.url}</td>
      <td className="td-tee">{tableRecord && tableRecord.CatMulti_To_ModFile && tableRecord.CatMulti_To_ModFile.name}</td>
      <td className="td-tee">
        <button
          className="table-button-edit"
          type="button"
          onClick={(event) => handleEditClick(event, tableRecord)}
        >
        <i className="fa fa-edit"></i>
        </button>
        <button type="button" className="table-button-delete" onClick={() => handleDeleteClick(tableRecord.id)}>
        <i className="fa fa-trash"></i>
        </button>
        <button type="button" className="table-button-preview" onClick={() => handlePreviewMultimediaClick(tableRecord.id)}>
        <i className="fa fa-search"></i>
        </button>
      </td>
    </tr>
  );
};

export default ReadOnlyRow;
